import { publicUrlFor } from "../../../../globals/constants";
import { NavLink } from "react-router-dom";
import { register } from 'swiper/element/bundle';
register();

function SectionSlider1() {
    return (
        <>
            <div className="sx-bnr-1-wrap-outer home-1-slider">
                {/* swiper slides */}
                <swiper-container
                    loop="true"
                    space-between="30"
                    effect="fade"
                    navigation-next-el=".swiper-button-next"
                    navigation-perv-el=".swiper-button-prev"
                    pagination-el=".swiper-pagination"
                    pagination-clickable="true"
                    autoplay-delay="7000"
                    autoplay-disable-on-interaction="true"
                    class="swiper-wrapper"
                >
                    <swiper-slide class="sx-bnr-1-wrap swiper-slide overlay-overlay" style={{ backgroundImage: `url(${publicUrlFor("images/main-slider/slider1/infotrace-analyticscreditscoring.jpg")})` }}>
                        <div className="sx-bg-overlay opacity-0.1 sx-bg-primary-1" />
                        <div className="container">
                            <div className="sx-bnr-1-content">
                                <h2 className="sx-bnr-1-large-title">Cutting Edge Machine Learning Algorithms.</h2>
                                <div className="sx-bnr-1-info">we are at the forefront of innovation in the financial services industry with our state-of-the-art proprietary algorithm</div>
                                <div className="sx-bnr-readmore">
                                    <NavLink to="/about-us" className="site-button sx-btn-primary icon">
                                        <i className="fa  fa-long-arrow-right" />
                                        Read More
                                    </NavLink>
                                </div>
                                <div className="sx-bnr-video">
                                    <a href="https://www.youtube.com/watch?v=D_UU95AY2s4" className="mfp-video circle">
                                        <i className="flaticon-play" />
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="sx-bnr-text-masking">
                            <div className="light">
                                <h1 className="animate-charcter">Infotrace</h1>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide class="sx-bnr-1-wrap swiper-slide overlay-overlay" style={{ backgroundImage: `url(${publicUrlFor("images/main-slider/slider1/infotrace-analytics-home.jpg")})` }}>
                        <div className="sx-bg-overlay opacity-0.1 sx-bg-primary-1" />
                        <div className="container">
                            <div className="sx-bnr-1-content">
                                <h2 className="sx-bnr-1-large-title">Automation & Workflow Optimization</h2>
                                <div className="sx-bnr-1-info">Automation solutions are designed to enhance productivity and enable your team to focus on strategic activities.</div>
                                <div className="sx-bnr-readmore">
                                    <NavLink to="/about-us" className="site-button sx-btn-primary icon">
                                        <i className="fa  fa-long-arrow-right" />
                                        Read More
                                    </NavLink>
                                </div>
                                <div className="sx-bnr-video">
                                    <a href="https://www.youtube.com/watch?v=D_UU95AY2s4" className="mfp-video circle">
                                        <i className="flaticon-play" />
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="sx-bnr-text-masking">
                            <div className="light">
                                <h1 className="animate-charcter">Infotrace</h1>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide class="sx-bnr-1-wrap swiper-slide overlay-overlay" style={{ backgroundImage: `url(${publicUrlFor("images/main-slider/slider1/infotrace-analytics.jpg")})` }}>
                        <div className="sx-bg-overlay opacity-0.1 sx-bg-primary-1" />
                        <div className="container">
                            <div className="sx-bnr-1-content">
                                <span className="sx-bnr-1-small-title" data-swiper-parallax="-300">We are The best</span>
                                <h2 className="sx-bnr-1-large-title">Data-driven Solutions, Real-world Impact.</h2>
                                <div className="sx-bnr-1-info">Specialization in collecting and transforming raw data into meaningful patterns, trends, behaviors, and actionable knowledge</div>
                                <div className="sx-bnr-readmore">
                                    <NavLink to="/about-us" className="site-button sx-btn-primary icon">
                                        <i className="fa  fa-long-arrow-right" />
                                        Read More
                                    </NavLink>
                                </div>
                                <div className="sx-bnr-video">
                                    <a href="https://www.youtube.com/watch?v=D_UU95AY2s4" className="mfp-video circle">
                                        <i className="flaticon-play" />
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="sx-bnr-text-masking">
                            <div className="light">
                                <h1 className="sx-title">Infotrace</h1>
                            </div>
                        </div>
                    </swiper-slide>
                </swiper-container>
                {/* !swiper slides */}
                {/* Add Arrows */}
                <div className="swiper-button-next" />
                <div className="swiper-button-prev" />
            </div>
        </>
    )
}

export default SectionSlider1;